<template>
  <vSelect
      v-model="model"
      :name="field"
      :options="options"
      :options-value="optionsValue"
      :options-label="optionsLabel"
      :disabled="disabled"
      :multiple="multiple"
      :search="search"
      :show-count="showCount"
      :placeholder="placeholder"
      :clear-button="clearButton"
      class="h-full-width"
      :class="missingClass"
  >
  </vSelect>
</template>

<script>
  import lodash from 'lodash';
  import vSelect from 'vue-strap/src/Select.vue';

  export default {
    name: 'StoreConnectedSelect',
    components: {
      vSelect,
    },
    props: {
      store: {
        type: String,
        required: true,
      },
      action: {
        type: String,
        default: 'setProperty',
      },
      name: {
        type: String,
        required: true,
      },
      field: {
        type: String,
      },
      subProp: {
        default: false,
      },
      options: {
        type: Array,
      },
      optionsValue: {
        type: String,
        default: 'value',
      },
      optionsLabel: {
        type: String,
        default: 'label',
      },
      placeholder: {
        type: String,
        default: null,
      },
      showCount: {
        type: Boolean,
        default: false,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      search: {
        type: Boolean,
        default: false,
      },
      autoSelect: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      callback: {
        default: null,
      },
      required: {
        type: Boolean,
        default: false,
      },
      clearButton: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        model: null,
        init: false,
      };
    },
    mounted() {
      if (this.multiple) {
        this.model = [];
      }
      this.model = this.storeValue;
      this.init = true;
    },
    watch: {
      model() {
        if (this.init) {
          this.updateStore();
          if (this.callback) {
            this.$store.dispatch(this.callback, this.model);
          }
        }
      },
      storeValue() {
        if (this.init) {
          this.model = this.storeValue;
        }
      },
      options() {
        // if autoSelect option is active and there is only one choice, select it
        if (this.autoSelect && this.options.length === 1) {
          this.model = this.options[0][this.optionsValue];
          return;
        }
        // unselect any of our previous values that are no longer options
        if (this.multiple) {
          this.model = lodash.filter(this.model, (value) => lodash.map(this.options, this.optionsValue).includes(value));
        } else if (!lodash.map(this.options, this.optionsValue).includes(this.model)) {
          this.model = null;
        }
      },
    },
    computed: {
      modelName() {
        return this.subProp || this.name;
      },
      storeValue() {
        if (this.subProp) {
          return this.$store.getters[`${this.store}/${this.name}`][this.subProp];
        }
        return this.$store.getters[`${this.store}/${this.name}`];
      },
      isMissing() {
        if (!this.required) {
          return false;
        }
        if (this.multiple && this.model && this.model.length === 0) {
          return true;
        }
        if (!this.model) {
          return true;
        }
        return false;
      },
      missingClass() {
        return this.isMissing ? 'form__item--missing' : '';
      },
    },
    methods: {
      updateStore() {
        if (this.subProp) {
          this.$store.dispatch(`${this.store}/${this.action}`, {
            object: this.name,
            key: this.modelName,
            value: this.model
          });
        } else {
          this.$store.dispatch(`${this.store}/${this.action}`, {
            key: this.modelName,
            value: this.model
          });
        }
      },
      // formatSelectDisplay(selectBox, numItems) {
      //   // Check if multiple items selected
      //   if (numItems > 1) {
      //     this.aggregateDisplay(selectBox, numItems);
      //   } else {
      //     this.limitDisplayLength(selectBox, numItems);
      //   }
      // },
      // aggregateDisplay(selectBox, numItems) {
      //   this.$nextTick(() => {
      //     document.querySelectorAll(`${selectBox} .btn-content`)[0].innerHTML = (`${numItems} Selected`);
      //   });
      // },
      // limitDisplayLength(selectBox) {
      //   const maxDisplayLength = 15;
      //   this.$nextTick(() => {
      //     const text = document.querySelectorAll(`${selectBox} .btn-content`)[0].innerHTML;
      //     let modifiedText = text;
      //     if (text.length > maxDisplayLength) {
      //       modifiedText = `${text.substring(0, maxDisplayLength - 3)} ...`;
      //     } else if (text === '') {
      //       modifiedText = '(changed)';
      //     }
      //     document.querySelectorAll(`${selectBox} .btn-content`)[0].innerHTML = modifiedText;
      //   });
      // },
    }
  };
</script>
